import React from 'react'
import ProductionCostEdit from "./ProductionCostEdit";
import ProductionCostDelete from "./ProductionCostDelete";

const ProductionCostActions = ({record, updater}) => {

    return(
        <React.Fragment>
            <ProductionCostEdit costId={record.id} updater={updater} />
            <ProductionCostDelete costId={record.id} updater={updater} />
        </React.Fragment>
    )
}
export default ProductionCostActions